export default __webpack_public_path__ + "static/media/megaphone-logo.ed3759c3.png";